import React from 'react';
import { FechaMMMDeString, YYYYMMDDdeDate } from "../../Funciones/Funciones";
import classes from "./RecurrenteItem.module.css"

function ItemRecurrente(props) {
  const fechaHoy = YYYYMMDDdeDate(new Date());
  //console.log("RI", props.recurrente.RealizarEn > fechaHoy);
  return (
    //color de fondo
    <div
      className={classes.back}
      id={"fondoItem"}
      style={{
        backgroundColor:
          props.recurrente.RealizarEn > fechaHoy
            ? "#fff"  //si no ha pasado la fecha de pago, en blanco
            : props.tipo !== "Catalogo" //si ya paso la fecha de pago 
              ? "#c36770" //si no estamos viendo el catalogo, rojo
              : props.recurrente.Estatus !== "OK" //si no esta activo el recurrente
                ? "#f00" //si no esta activo el recurrente, rojo 
                : "#ffd", //si esta actiuvo el recurrente, blanco
      }}
    >
      <label className={classes.nombre}>{props.recurrente.Nombre}</label>
      <label className={classes.nombre}>{props.recurrente.Frecuencia}</label>
      <label className={classes.otros}>
        {props.recurrente.RealizarEn === undefined
          ? "Fecha Inicia:"
          : "Fecha pago:"}
      </label>

      <label className={classes.otros}>
        {props.recurrente.RealizarEn === undefined
          ? FechaMMMDeString(props.recurrente.Inicia)
          : FechaMMMDeString(props.recurrente.RealizarEn)}
      </label>

      <label className={classes.otrosN}>
        {props.recurrente.Estatus !== "OK" ? "BAJA" : null}
      </label>

      <div className={classes.divBotones}>
        {//Boton pago. Solo se muestra si no estamos viendo el catalogo y somos administradores
          props.nivel === 1 && props.tipo !== "Catalogo" ? (
            <button
              id={props.recurrente.IDRec}
              onClick={(ev) => {
                ev.stopPropagation();
                props.AgregaPagoHandler(props.recurrente);
              }}
            >
              <i id={props.recurrente.IDRec} className="fas fa-dollar-sign"></i>
            </button>
          ) : null}
        {//Boton asignar. Solo se muestra si no estamos viendo el catalogo y somos administradores
          props.nivel === 1 && props.tipo !== "Catalogo" ? (
            <button
              id={props.recurrente.IDRec}
              onClick={(ev) => {
                ev.stopPropagation();
                props.SeleccionaPagoHandler(props.recurrente);
              }}
            >
              <i id={props.recurrente.IDRec} className="fas fa-search"></i>
            </button>
          ) : null}
        {//Boton eliminar pendiente de asignacion. Solo se muestra si no estamos viendo el catalogo y somos administradores
          props.nivel === 1 && props.tipo !== "Catalogo" ? (
            <button
              id={props.recurrente.IDRec}
              onClick={(ev) => {
                ev.stopPropagation();
                props.EliminaPagoHandler(props.recurrente);
              }}
            >
              <i id={props.recurrente.IDRec} className="fas fa-times"></i>
            </button>
          ) : null}
        {//Boton editar recurrente. Solo se muestra si estamos viendo el catalogo y somos administradores
          props.nivel === 1 && props.tipo === "Catalogo" ? (
            <button
              id={props.recurrente.IDRec}
              onClick={(ev) => {
                ev.stopPropagation();
                props.EditaRecurrenteHandler(props.recurrente);
              }}
            >
              <i id={props.recurrente.IDRec} className="fas fa-file-alt"></i>
            </button>
          ) : null}
        {//Boton eliminar recurrente. Solo se muestra si estamos viendo el catalogo y somos administradores y no esta dado de baja
          props.nivel === 1 && props.tipo === "Catalogo" && props.recurrente.Estatus === "OK" ? (
            <button
              id={props.recurrente.IDRec}
              onClick={(ev) => {
                ev.stopPropagation();
                props.EliminaRecurrenteHandler(props.recurrente);
              }}
            >
              <i id={props.recurrente.IDRec} className="fas fa-times"></i>
            </button>
          ) : null}
      </div>
    </div>
  );
}

export default ItemRecurrente;
